import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import Button from '../../../../components/components-ui/Button/Button'
import api from '../../../../services/Api'
import { Grid, Col } from '../../../../components/Grid'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'
import { useParams, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

function Action() {
  const [estabelecimento, setEstabelecimento] = useState('')
  const { id } = useParams()
  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg)
    } else {
      toast.error(msg)
    }
  }

  async function createEstabelecimento(values) {
    const response = await api.post('/estabelecimento/create/', {
      estabelecimento: values.nomeEstabelecimento,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      return
    }
    showAlert(1, response.data.msg)
  }

  async function editarEstabelecimento(values) {
    const response = await api.put(`/estabelecimento/edit/${id}`, {
      estabelecimento: values.nomeEstabelecimento,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      return
    }
    showAlert(1, response.data.msg)
  }

  useEffect(() => {
    async function getEstabelecimento() {
      const response = await api.get(`/estabelecimento/show/${id}`)
      setEstabelecimento(response.data.estabelecimento)
    }
    getEstabelecimento()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigate = useNavigate()
  const validadtionSchema = Yup.object().shape({
    nomeEstabelecimento: Yup.string().required('*Campo Obrigatório'),
  })
  return (
    <Container>
      <h3>
        {id ? 'Edição de Estabelecimento' : 'Cadastro de Estabelecimento'}
      </h3>
      <section className={styles.action_section}>
        <Formik
          initialValues={{ nomeEstabelecimento: estabelecimento }}
          enableReinitialize={true}
          onSubmit={
            id
              ? (values) => editarEstabelecimento(values)
              : (values) => createEstabelecimento(values)
          }
          validationSchema={validadtionSchema}
        >
          {({ errors, touched }) => (
            <Form>
              <Grid>
                <Col size={12}>
                  <label> Nome Estabelecimento </label>
                  <Field type="text" name="nomeEstabelecimento" />
                  {errors.nomeEstabelecimento && touched.nomeEstabelecimento ? (
                    <span className={styles.alertError}>
                      {errors.nomeEstabelecimento}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <Button type="submit" title={'Salvar'} />
                  <Button
                    type="button"
                    title="Voltar"
                    color="secondary"
                    onClick={() => {
                      navigate('/usina/estabelecimento')
                    }}
                  />
                </Col>
              </Grid>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  )
}

export default Action
